var _polygon, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAmf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "141.73px",
    height: "56.69px",
    viewBox: "0 0 141.73 56.69",
    enableBackground: "new 0 0 141.73 56.69",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#DB002E",
    points: "130.067,24.874 130.067,30.343 110.188,30.343 110.188,37.681 128.953,37.681 128.953,42.575  110.188,42.575 110.188,54.806 103.473,54.806 103.473,24.874 "
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    width: 141.73,
    height: 56.69
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_2_)",
    fill: "#003867",
    d: "M38.633,54.806h7.749L27.873,23.544h-0.308L9.055,54.806h7.214l2.567-4.627 h17.229L38.633,54.806z M21.404,45.552l6.047-10.899l6.047,10.899H21.404z"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#SVGID_2_)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#003867",
    d: "M53.493,25.504c-1.331-0.286-2.59-0.49-3.787-0.629v29.931h6.255V32.724 c9.266,3.314,17.395,11.188,22.82,22.082h6.901C78.806,39.243,67.007,28.416,53.493,25.504"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DB002E",
    d: "M90.378,25.504c1.331-0.286,2.589-0.49,3.785-0.629v29.931H87.91V32.724 c-9.266,3.314-17.395,11.188-22.821,22.082h-6.9C65.065,39.243,76.862,28.416,90.378,25.504"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003867",
    d: "M33.83,7.064l0.741-1.58l0.741,1.58H33.83z M32.43,8.475h0.736l0.376-0.814h2.045l0.37,0.814h0.731 l-1.722-3.546h-0.79L32.43,8.475z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003867",
    d: "M41.542,6.952c0,1.142-0.727,1.61-1.883,1.61c-1.157,0-1.883-0.469-1.883-1.61V4.929h0.694v1.975 c0,0.585,0.209,1.063,1.189,1.063c0.98,0,1.191-0.478,1.191-1.063V4.929h0.692V6.952z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#003867",
    points: "44.405,5.523 42.819,5.523 42.819,4.928 46.685,4.928 46.685,5.523 45.099,5.523 45.099,8.475  44.405,8.475  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003867",
    d: "M49.706,7.967c-0.663,0-1.419-0.273-1.419-1.278c0-0.853,0.61-1.254,1.419-1.254 c0.811,0,1.419,0.401,1.419,1.254C51.125,7.694,50.37,7.967,49.706,7.967 M47.594,6.728c0,0.737,0.434,1.835,2.112,1.835 c1.679,0,2.113-1.098,2.113-1.835c0-0.971-0.552-1.888-2.113-1.888C48.146,4.84,47.594,5.757,47.594,6.728"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003867",
    d: "M53.933,6.504V5.503h1.337c0.566,0,0.854,0.083,0.854,0.498c0,0.419-0.288,0.503-0.854,0.503H53.933z  M53.241,8.475h0.692V7.08h1.098l1.029,1.395h0.852l-1.087-1.443c0.522-0.03,0.99-0.391,0.99-1.045 c0-0.868-0.604-1.058-1.442-1.058h-2.133V8.475z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 58.439,
    y: 4.929,
    fill: "#003867",
    width: 0.694,
    height: 3.546
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#003867",
    points: "62.061,5.523 60.476,5.523 60.476,4.928 64.339,4.928 64.339,5.523 62.754,5.523 62.754,8.475  62.061,8.475  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003867",
    d: "M67.263,3.971h0.686l-0.782,0.698h-0.43L67.263,3.971z M65.684,4.928h3.182v0.595h-2.487v0.824h2.141 v0.594h-2.141v0.938h2.545v0.595h-3.24V4.928z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003867",
    d: "M33.227,12.401h1.321c0.722,0,1.459,0.307,1.459,1.346c0,1.395-1.176,1.439-1.526,1.439h-1.254V12.401z  M32.798,15.566h1.614c0.937,0,2.035-0.361,2.035-1.805c0-1.162-0.795-1.741-1.898-1.741h-1.75V15.566z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#003867",
    points: "37.866,12.021 41.027,12.021 41.027,12.401 38.295,12.401 38.295,13.533 40.578,13.533  40.578,13.913 38.295,13.913 38.295,15.186 41.085,15.186 41.085,15.567 37.866,15.567  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003867",
    d: "M42.426,14.552c0.206,0.273,0.547,0.722,1.61,0.722c0.547,0,1.292-0.156,1.292-0.707 c0-1.079-3.092-0.132-3.092-1.571c0-0.755,0.698-1.062,1.664-1.062c0.937,0,1.512,0.384,1.756,0.726l-0.312,0.253 c-0.147-0.166-0.487-0.62-1.453-0.62c-0.713,0-1.216,0.186-1.216,0.635c0,1.072,3.093,0.048,3.093,1.639 c0,0.595-0.577,1.088-1.781,1.088c-1.161,0-1.589-0.484-1.893-0.82L42.426,14.552z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#003867",
    points: "49.707,12.021 50.369,12.021 51.682,15.005 52.994,12.021 53.657,12.021 53.657,15.567  53.263,15.567 53.263,12.401 53.253,12.401 51.868,15.567 51.506,15.567 50.112,12.401 50.101,12.401 50.101,15.567  49.707,15.567  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003867",
    d: "M56.072,14.264l0.951-1.907l0.952,1.907H56.072z M54.936,15.566h0.478l0.464-0.922h2.288l0.458,0.922 h0.484l-1.82-3.546h-0.525L54.936,15.566z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003867",
    d: "M60.813,12.401h1.522c0.62,0,1.083,0.088,1.083,0.605c0,0.521-0.464,0.609-1.083,0.609h-1.522V12.401z  M60.385,15.566h0.428v-1.57h1.396l1.142,1.57h0.531l-1.17-1.58c0.428-0.02,1.116-0.235,1.116-0.975 c0-0.869-0.829-0.991-1.395-0.991h-2.049V15.566z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003867",
    d: "M69.14,14.625c-0.38,0.737-1.039,1.03-1.901,1.03c-1.376,0-2.026-0.826-2.026-1.854 c0-1.221,0.825-1.869,2.019-1.869c0.761,0,1.538,0.293,1.855,1.015l-0.371,0.171c-0.249-0.581-0.8-0.825-1.478-0.825 c-1.015,0-1.586,0.552-1.586,1.562c0,0.814,0.551,1.419,1.625,1.419c0.701,0,1.19-0.293,1.482-0.834L69.14,14.625z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#003867",
    points: "70.536,12.021 70.964,12.021 70.964,13.522 73.754,13.522 73.754,12.021 74.185,12.021  74.185,15.567 73.754,15.567 73.754,13.903 70.964,13.903 70.964,15.567 70.536,15.567  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003867",
    d: "M77.462,11.093h0.556l-0.723,0.693h-0.356L77.462,11.093z M75.857,12.021h3.162v0.38h-2.734v1.132h2.284 v0.38h-2.284v1.272h2.792v0.381h-3.22V12.021z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003867",
    d: "M80.416,14.552c0.206,0.273,0.546,0.722,1.611,0.722c0.547,0,1.293-0.156,1.293-0.707 c0-1.079-3.092-0.132-3.092-1.571c0-0.755,0.695-1.062,1.661-1.062c0.936,0,1.515,0.384,1.758,0.726l-0.313,0.253 c-0.147-0.166-0.487-0.62-1.453-0.62c-0.711,0-1.215,0.186-1.215,0.635c0,1.072,3.092,0.048,3.092,1.639 c0,0.595-0.575,1.088-1.78,1.088c-1.16,0-1.588-0.484-1.894-0.82L80.416,14.552z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#003867",
    points: "87.698,12.021 90.936,12.021 90.936,12.401 88.127,12.401 88.127,13.522 90.498,13.522  90.498,13.903 88.127,13.903 88.127,15.567 87.698,15.567  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92.224,
    y: 12.021,
    fill: "#003867",
    width: 0.431,
    height: 3.546
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#003867",
    points: "94.312,12.021 94.921,12.021 97.561,14.938 97.561,12.021 97.989,12.021 97.989,15.567  97.561,15.567 94.722,12.401 94.722,15.567 94.312,15.567  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003867",
    d: "M100.406,14.264l0.95-1.907l0.951,1.907H100.406z M99.268,15.566h0.479l0.462-0.922h2.287l0.458,0.922 h0.485l-1.819-3.546h-0.527L99.268,15.566z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#003867",
    points: "104.718,12.021 105.326,12.021 107.964,14.938 107.964,12.021 108.395,12.021 108.395,15.567  107.964,15.567 105.126,12.401 105.126,15.567 104.718,15.567  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003867",
    d: "M113.741,14.625c-0.382,0.737-1.042,1.03-1.903,1.03c-1.375,0-2.024-0.826-2.024-1.854 c0-1.221,0.823-1.869,2.02-1.869c0.763,0,1.536,0.293,1.854,1.015l-0.372,0.171c-0.248-0.581-0.799-0.825-1.477-0.825 c-1.015,0-1.586,0.552-1.586,1.562c0,0.814,0.552,1.419,1.626,1.419c0.702,0,1.188-0.293,1.481-0.834L113.741,14.625z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115.122,
    y: 12.021,
    fill: "#003867",
    width: 0.428,
    height: 3.546
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#003867",
    points: "117.209,12.021 120.37,12.021 120.37,12.401 117.638,12.401 117.638,13.533 119.921,13.533  119.921,13.913 117.638,13.913 117.638,15.186 120.429,15.186 120.429,15.567 117.209,15.567  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003867",
    d: "M122.165,12.401h1.521c0.62,0,1.084,0.088,1.084,0.605c0,0.521-0.464,0.609-1.084,0.609h-1.521V12.401z  M121.735,15.566h0.43v-1.57h1.396l1.143,1.57h0.53l-1.171-1.58c0.428-0.02,1.116-0.235,1.116-0.975 c0-0.869-0.829-0.991-1.396-0.991h-2.048V15.566z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003867",
    d: "M126.837,14.552c0.206,0.273,0.546,0.722,1.61,0.722c0.546,0,1.293-0.156,1.293-0.707 c0-1.079-3.092-0.132-3.092-1.571c0-0.755,0.696-1.062,1.662-1.062c0.938,0,1.514,0.384,1.757,0.726l-0.312,0.253 c-0.146-0.166-0.486-0.62-1.452-0.62c-0.715,0-1.218,0.186-1.218,0.635c0,1.072,3.095,0.048,3.095,1.639 c0,0.595-0.576,1.088-1.78,1.088c-1.161,0-1.592-0.484-1.895-0.82L126.837,14.552z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27.565,
    y: 1.644,
    fill: "#003867",
    width: 0.307,
    height: 17.206
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmf);
export default __webpack_public_path__ + "static/media/amf.8cdc37e750c764b10166b4910d7d7495.svg";
export { ForwardRef as ReactComponent };